module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1266.5d2cf204.png";